<template>
	<div class="login">
		<site-header :userAuthenticated="false"></site-header>

		<div class="form-fields group">
			<h2>User Login</h2>
			<form v-on:submit="submit($event)">
				<text-input class="field " :label="'Username'" :identifier="'username'" :display="'row'" :label-width="250" v-model="username"></text-input>
				<text-input class="field " :label="'Password'" :identifier="'password'" :display="'row'" :type="'password'" :label-width="250" v-model="password" :error="error" @valueChanged="formChanged"></text-input>
				<a class="reset" href="https://kbsglobe.com/ResetPassword.aspx">Forgot your password?</a>
				<!--<input-button class="btn-submit" :btn-class="'btn-primary'" data-callback="submit" data-sitekey="">Login</input-button>-->
				<input-button class="btn-submit" :btn-class="'btn-primary'">Login</input-button>
				<!--<div class="g-recaptcha" data-sitekey="6LeMpYMUAAAAADQ5kEl89Z1Gc84hJhZR5nFLqcgV" data-callback="onSubmit" data-size="invisible"></div>-->
			</form>
			
		</div>
	</div>
</template>

<script>
	import SiteHeader from '../components/header/SiteHeader'
	import InputButton from '../components/reusable/InputButton'
	import TextInput from '../components/reusable/TextInput'
	import { mapActions } from 'vuex'

	export default {
		name: 'Login',
		data() {
			return {
				password: '',
				username: '',
				error:''
			}
		},
		mounted() {
			var reCaptcha = document.createElement('script');
			reCaptcha.async = true;
			reCaptcha.defer = true;
			reCaptcha.setAttribute('src', 'https://www.google.com/recaptcha/api.js');			
			document.head.appendChild(reCaptcha);
		},
		methods: {
			...mapActions('authmodule', [
				'login' 
			]),
			submit: function (event) {

				// grecaptcha.execute();

				if (event) {
					event.preventDefault();
				}
				this.error = '';
				var that = this;

				var result = this.login({ Username: this.username, Password: this.password }).then(function (result) {

					if (result === false) {
						that.error = 'Invalid Username or Password';
					}
				});
			},
			formChanged() {
				this.error = '';
			}
		},
		components: {
			SiteHeader,
			InputButton,
			TextInput
		}
	}
</script>

<style lang="scss" scoped>
	.form-fields {
		background: #fff;
		padding: 20px;
		width: 100%;
		max-width: 500px;
		margin: 100px auto 0 auto;

		.field{
			margin-bottom: 20px;
			position:relative;
		}

		.btn-submit {
			float: right;
		}

		@media only screen and (max-width: 800px) {
			margin-top:0;
		}

		.reset {
			line-height: 2em;
		}
	}
</style>
